import React, { useState, useEffect } from "react";
import Img from '../../assets/redcat-imagine.png'; 
import Logo from "../../assets/red-cat-logo.png";
import Imagine from "../../assets/imagine-logo.png";
import { useNavigate,Link } from "react-router-dom";
import { db } from "../../firebase/firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useDistributorAuth } from "../../context/DistributorAuthContext"; // Import context

function DistributorLogin() {
  const [username, setUsername] = useState(""); 
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setDistributor } = useDistributorAuth(); 
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedDistributor = localStorage.getItem("distributor");
    if (storedDistributor) {
      navigate("/distributor/stats", { replace: true }); // Redirect to stats if already logged in
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setError("Username and Password are required.");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Check Firestore for distributor credentials
      const usersCollection = collection(db, "users");
      const q = query(
        usersCollection,
        where("userName", "==", username.toLowerCase()),
        where("password", "==", password)
      );

      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError("Invalid credentials or not a distributor.");
      } else {
        const userDoc = querySnapshot.docs[0].data();
        if (userDoc.role.toLowerCase() !== "distributor") {
          setError("Invalid credentials or not a distributor.");
        } else {
          setDistributor(userDoc); // Set the distributor data in the context
          localStorage.setItem("distributor", JSON.stringify(userDoc)); // Store distributor info in localStorage
          navigate("/distributor/stats", { replace: true }); // Redirect to stats page after login
        }
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = () => {
    setShowPassword(!showPassword);
  };




  return (
    <div className="bg-black h-[96vh] w-[99vw] flex flex-col items-center justify-center">
      <div className="bg-gradient-to-r from-transparent via-red-600 to-transparent h-[70px] flex justify-center items-center w-full mt-[-60px] mb-[30px]">
        <p className="text-white text-xl">
          Innovation | Entertainment | Sustainability
        </p>
      </div>
      <div className="text-white mb-3">
        <span className="text-3xl font-semibold  bg-gradient-to-r text-white bg-clip-text text-transparent">
          Distributor Panel
        </span>
      </div>
      <div className="w-[70%] min-h-[430px] h-[60vh] rounded-[20px] overflow-hidden flex justify-center">
        <div className="bg-white w-[40%] h-full flex items-center justify-center">
          <img src={Img} alt="img.png" className="w-[130%]" />
        </div>
        <div className="bg-[#F70D1A] w-[60%] h-full">
          <div className="flex items-center justify-center h-[45px] bg-gradient-to-r from-transparent via-black to-transparent mt-[100px]">
            <div className="bg-white w-[6em] h-[6em] rounded-full flex justify-center items-center mr-[20px]">
              <img src={Logo} alt="img.png" className="w-[130%]" />
            </div>
            <div className="text">
              <img src={Imagine} alt="img.png" className="w-[19em] mt-[1px]" />
              <p className="text-right text-white mt-[-14px]">
                Let&apos;s be the change
              </p>
            </div>
          </div>
          <form onSubmit={handleLogin}>
            <div className="flex flex-col items-center justify-center mt-[15%]">
              <Inp
                plc="User Name"
                align="left"
                value={username}
                fnc={(e) => setUsername(e.target.value)}
              />
             <Inp plc="Password" align={"right"} value={password} fnc={(e) => setPassword(e.target.value)} type={showPassword ? "text" : "password"} />

                 <label style={{color:"white",textAlign:"left"}}>
        <input 
          type="checkbox" 
          checked={showPassword} 
          onChange={handleCheckboxChange} 
          className="mr-2"
        />
        Show Password
      </label>

            </div>
            <div className="flex items-center justify-center m-[10px]">
              <input
                type="submit"
                value={loading ? "Logging in..." : "Login"}
                className="border border-black bg-white rounded-[14px] py-[0.7rem] px-[1.6rem] w-[20%]"
                disabled={loading}
              />
            </div>
          </form>
       
          {error && <p className="text-black">{error}</p>}
        </div>
      </div>
         <div className="w-full text-white grid place-items-center text-md underline cursor-pointer mt-3">
            <Link to="/"> Login As a Admin</Link>
          </div>
    </div>
  );
}

function Inp({ plc, align, value, fnc, type }) {
  return (
    <input
      type={type}
      placeholder={plc}
      style={{ textAlign: align }}
      value={value}
      onChange={fnc}
      className="bg-transparent border-t-0 border-l-0 border-r-0 border-white text-white outline-none w-[50%] py-[10px] px-0 border-b-2 mb-[10px] placeholder-white"
    />
  );
}

export default DistributorLogin;
